import React, { useState } from 'react';
import {
  Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses,
  TableContainer, TableHead, TableRow
} from '@mui/material';
import { Col, Container, Form, Row } from 'react-bootstrap';
import Home from '../home/Home'
import TrackService from '../../Services/TrackService';
import Snacbar from '../Snacbar';
import { useEffect } from 'react';
import { getUserId } from '../Utils/Common';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: 'rgb(61, 195, 177)',
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
  },
}));

function Tracking() {
  const [Trackingvalues, setTrackingvalues] = useState({
    job_no: '', mawb_no: '', hawb_no: '', job_status: '',
  });

  const [dialogeValues, setdialogeValues] = useState({
    JobNo: '', BillprintTo: ''
  })

  const [BillPrintTo, setBillPrintTo] = useState([]);

  const [open, setOpen] = useState(false);
  const [severity, setseverity] = useState('');
  const [message, setMessage] = useState('');

  const [radioValues, setRadioValues] = useState('1');
  const [LabelJob, setLabelJob] = useState('Job.No');

  const [boeCopy, setboeCopy] = useState('');
  const [clCopy, setclCopy] = useState('');
  const [invoiceCopy, setinvoiceCopy] = useState('');
  const [packingCopy, setpackingCopy] = useState('');
  const [dutyCopy, setdutyCopy] = useState('');
  const [tspCopy, settspCopy] = useState('');

  const [TrackingDetailsOperation, setTrackingDetailsOperation] = useState([]);
  const [JobTrackingDetailsOperation, setJobTrackingDetailsOperation] = useState([]);
  const [AllChargesList, setAllChargesList] = useState([]);

  const [NgBillOpenDialog, setNgBillOpenDialog] = useState(false);
  const [AllChargesListOpenDialog, setAllChargesListOpenDialog] = useState(false);

  const Trackingjob_noChangeHandle = (e) => {
    setTrackingvalues({ ...Trackingvalues, job_no: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    var consignmentNumber, MAWBNo, hawb_no = '';
    if (e.target.value !== '') {
      if (radioValues === '1') {
        MAWBNo = '-1'
        hawb_no = '-1'
        consignmentNumber = e.target.value;
      }
      else if (radioValues === '2') {
        MAWBNo = e.target.value;
        hawb_no = '-1'
        consignmentNumber = '-1';
      }
      else if (radioValues === '3') {
        MAWBNo = '-1'
        hawb_no = e.target.value;
        consignmentNumber = '-1';
      }
      let details = { consignmentNumber: consignmentNumber, MAWBNo: MAWBNo, hawb_no: hawb_no }
      TrackService.getDocumentDownload(details).then((res) => {
        const data = res.data;
        const lastResult = data.map((item) => item);
        if (!lastResult[0]) {
          setboeCopy('null'); setclCopy('null');
          setinvoiceCopy('null'); setpackingCopy('null');
          setdutyCopy('null'); settspCopy('null');
        } else {
          setboeCopy(lastResult[0].BOECopy); setclCopy(lastResult[0].checklistCopy);
          setinvoiceCopy(lastResult[0].invoiceImage); setpackingCopy(lastResult[0].packingListImage);
          setdutyCopy(lastResult[0].dutyPaidCopy); settspCopy(lastResult[0].tspPaidCopy);
        }
      })
    } else {
      setOpen(true); setseverity('warning'); setMessage('Please Enter The ' + LabelJob + '..!!')
    }
  }

  const Trackingjob_statusChangeHandle = (e) => {
    setTrackingvalues({ ...Trackingvalues, job_status: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  //DialogChangeHandle
  const DialogJobNoChangeHandle = (e) => {
    setdialogeValues({ ...dialogeValues, JobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }
  const DialogBillPrintToChangeHandle = (e) => {
    setdialogeValues({ ...dialogeValues, BillprintTo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  }

  const RadioTrackingChangeHandle = (e) => {
    setRadioValues(e.target.value)
    if (e.target.value === '1') {
      setLabelJob('Job.No');
      setdialogeValues({ ...dialogeValues, JobNo: '' })
    }
    else if (e.target.value === '2') {
      setLabelJob('MAWB/MBL.No');
      setdialogeValues({ ...dialogeValues, JobNo: '' })
    }
    else if (e.target.value === '3') {
      setLabelJob('HAWB/HBL.No');
      setdialogeValues({ ...dialogeValues, JobNo: '' })
    }
  }

  //getData
  const getDepData = async () => {
    TrackService.getBillPrintTo().then((res) => {
      setBillPrintTo(res.data);
    });
  }

  useEffect(() => {
    getDepData();
  }, []);

  //click events

  const getJobTrackingDetailsOperation = () => {
    var consignmentNumber, MAWBNo, hawb_no = '';
    if (radioValues === '1') {
      consignmentNumber = Trackingvalues.job_no
      MAWBNo = '-1'
      hawb_no = '-1'
    }
    else if (radioValues === '2') {
      consignmentNumber = '-1'
      MAWBNo = Trackingvalues.job_no
      hawb_no = '-1'
    }
    else if (radioValues === '3') {
      consignmentNumber = '-1'
      MAWBNo = '-1'
      hawb_no = Trackingvalues.job_no
    }
    let details = { consignmentNumber: consignmentNumber, MAWBNo: MAWBNo, hawb_no: hawb_no, importer_iec_no: '-1' }
    TrackService.getTrackingDetailsOperation(details).then((res) => {
      const data = res.data;
      const lastResult = data.map((item) => item);
      setTrackingvalues({ ...Trackingvalues, job_status: lastResult[0].status });
      setTrackingDetailsOperation(res.data)
    });
    TrackService.getJobTrackingDetailsOperation(details).then((res) => {
      setJobTrackingDetailsOperation(res.data);
    });
  }

  const downloadBOECopy = () => {
    if (boeCopy === 'null' || boeCopy === '' || !boeCopy) {
      setOpen(true); setseverity('warning'); setMessage('No Document Found');
    } else {
      let details = { docImage: boeCopy, fileName: 'BOE_' + Trackingvalues.job_no }
      TrackService.savePdftoFolder(details).then((res) => {

      })
    }
  }
  const downloadClCopy = () => {
    if (clCopy === 'null' || clCopy === '' || !clCopy) {
      setOpen(true); setseverity('warning'); setMessage('No Document Found');
    } else {
      let details = { docImage: clCopy, fileName: 'Checklist_' + Trackingvalues.job_no }
      console.log('details ' + JSON.stringify(details));
      console.log('clCopy ' + clCopy);
      TrackService.savePdftoFolder(details).then((res) => {

      })
    }
  }
  const downloadInvoiceCopy = () => {
    if (invoiceCopy === 'null' || invoiceCopy === '' || !invoiceCopy) {
      setOpen(true); setseverity('warning'); setMessage('No Document Found');
    } else {
      let details = { docImage: invoiceCopy, fileName: 'Invoice_' + Trackingvalues.job_no }
      TrackService.savePdftoFolder(details).then((res) => {

      })
    }
  }
  const downloadPackingListCopy = () => {
    if (packingCopy === 'null' || packingCopy === '' || !packingCopy) {
      setOpen(true); setseverity('warning'); setMessage('No Document Found');
    } else {
      let details = { docImage: packingCopy, fileName: 'PackingList_' + Trackingvalues.job_no }
      TrackService.savePdftoFolder(details).then((res) => {

      })
    }
  }
  const downloadDutyCopy = () => {
    if (dutyCopy === 'null' || dutyCopy === '' || !dutyCopy) {
      setOpen(true); setseverity('warning'); setMessage('No Document Found');
    } else {
      let details = { docImage: dutyCopy, fileName: 'Duty_' + Trackingvalues.job_no }
      TrackService.savePdftoFolder(details).then((res) => {

      })
    }
  }
  const downloadTspCopy = () => {
    if (tspCopy === 'null' || tspCopy === '' || !tspCopy) {
      setOpen(true); setseverity('warning'); setMessage('No Document Found');
    } else {
      let details = { docImage: tspCopy, fileName: 'TSP_' + Trackingvalues.job_no }
      TrackService.savePdftoFolder(details).then((res) => {

      })
    }
  }

  //dialogCLickEvent
  const BgBillShow = () => {
    if (dialogeValues.JobNo !== '') {

      TrackService.getGstNo(dialogeValues.JobNo).then((res) => {
        const data = res.data;
        const lastResult = data.map((item) => item);

        if (lastResult[0].gstBillNo === null || !lastResult[0].gstBillNo === '' || !lastResult[0].gstBillNo) {
          setOpen(true); setseverity('warning'); setMessage('This job has no bill no');
        } else {
          InvoiceBillPdfPrint();
        }
      })
    }
    else {
      document.getElementById('txt_ngbilljobNo').focus();
      setOpen(true); setseverity('warning'); setMessage("Kindly enter the Job No");
    }
  }

  const InvoiceBillPdfPrint = () => {
    if (dialogeValues.JobNo !== '') {
      var billBy = '';
      if (dialogeValues.BillprintTo === 'IMPORTER' || dialogeValues.BillprintTo === 'EXPORTER') {
        billBy = '1'
      } else {
        billBy = '2'
      }
      let details = {
        consignmentId: dialogeValues.JobNo, billNo: '-1', flagbill: 1, iecNo: '-1', fwdcode: '-1', billPaidBy: 'NGPILLAI',
        billBy: billBy, createdBy: getUserId(), fileName: dialogeValues.JobNo
      }
      TrackService.InvoiceBillPdfPrint(details).then((res) => {
        const message = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + message.toString());
        window.open('http://35.154.221.117:8081/ExportFiles/' + message.toString());
      }).catch(error => {
        setOpen(true); setseverity('warning'); setMessage(error.message);
      });
    } else {
      document.getElementById('txt_ngbilljobNo').focus(); setOpen(true); setseverity('warning'); setMessage("Kindly enter the Job No");
    }
  }

  const clear = () => {
    setdialogeValues({ ...dialogeValues, BillprintTo: 'IMPORTER', JobNo: '' })
  }



  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }

  const DialogNgBillHandleClose = () => {
    setNgBillOpenDialog(false);
    setdialogeValues({ ...dialogeValues, JobNo: '', BillprintTo: 'IMPORTER' });
  }
  const DialogNgBillHandleOpen = () => {
    setNgBillOpenDialog(true);
    if (radioValues === '1') {
      setdialogeValues({ ...dialogeValues, JobNo: Trackingvalues.job_no, BillprintTo: 'IMPORTER' });
    } else {
      setdialogeValues({ ...dialogeValues, JobNo: '', BillprintTo: 'IMPORTER' });
    }
  }

  const DialogAllChargListClose = () => {
    setAllChargesListOpenDialog(false);
  }
  const DialogAllChargListOpen = () => {
    if (Trackingvalues.job_no !== '') {
      setAllChargesListOpenDialog(true);
      TrackService.getAllChargesList(Trackingvalues.job_no).then((res) => {
        setAllChargesList(res.data);
      });
    } else {
      document.getElementById('mawbJobHawb_No').focus();
      setOpen(true); setseverity('warning'); setMessage('Kindly enter the job no');
    }
  }

  //keydown
  const TrackingJobNoKeyDown = (e) => {
    if (e.key === 'Enter') {
      getJobTrackingDetailsOperation();
      var consignmentNumber, MAWBNo, hawb_no = '';
      if (Trackingvalues.job_no !== '') {
        if (radioValues === '1') {
          MAWBNo = '-1'
          hawb_no = '-1'
          consignmentNumber = Trackingvalues.job_no;
        }
        else if (radioValues === '2') {
          MAWBNo = Trackingvalues.job_no;
          hawb_no = '-1'
          consignmentNumber = '-1';
        }
        else if (radioValues === '3') {
          MAWBNo = '-1'
          hawb_no = Trackingvalues.job_no;
          consignmentNumber = '-1';
        }
        let details = { consignmentNumber: consignmentNumber, MAWBNo: MAWBNo, hawb_no: hawb_no }
        TrackService.getDocumentDownload(details).then((res) => {
          const data = res.data;
          const lastResult = data.map((item) => item);
          if (!lastResult[0]) {
            setboeCopy('null'); setclCopy('null');
            setinvoiceCopy('null'); setpackingCopy('null');
            setdutyCopy('null'); settspCopy('null');
          } else {
            setboeCopy(lastResult[0].BOECopy); setclCopy(lastResult[0].checklistCopy);
            setinvoiceCopy(lastResult[0].invoiceImage); setpackingCopy(lastResult[0].packingListImage);
            setdutyCopy(lastResult[0].dutyPaidCopy); settspCopy(lastResult[0].tspPaidCopy);
          }
        })
      } else {
        setOpen(true); setseverity('warning'); setMessage('Please Enter The ' + LabelJob + '..!!')
      }
    }
  }

  const navigate = useNavigate();
  const BackBotton = () => {
    navigate('/besbupdation');
  }
  const ForwordBotton = () => {
    navigate('/fundreq');
  }
  return (
    <div>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div>
        <Dialog open={NgBillOpenDialog} onClose={DialogNgBillHandleClose}>
          <DialogTitle className='bg-info p-1'><center>NG Bill</center></DialogTitle>
          <DialogContent>
            <Container>
              <Col>
                <Form.Label>Job.No</Form.Label>
                <Form.Control value={dialogeValues.JobNo} onChange={DialogJobNoChangeHandle} id='txt_ngbilljobNo' />
                <Form.Label>BillPrintTo</Form.Label>
                <Form.Select value={dialogeValues.BillprintTo} onChange={DialogBillPrintToChangeHandle} id='BillPrintTo'>
                  <option value={''}></option>
                  {BillPrintTo.map((item) => (
                    <option key={item.serialNumber} value={item.billPaidTo}>{item.billPaidTo}</option>
                  ))}
                </Form.Select>
              </Col>
              <br></br>
              <Button size='small' variant='contained' onClick={BgBillShow}>Show</Button>&nbsp;
              <Button size='small' variant='contained' onClick={clear}>Clear</Button>
            </Container>
          </DialogContent>
        </Dialog>
        {/* AllChargesList */}
        <Dialog open={AllChargesListOpenDialog} onClose={DialogAllChargListClose}>
          <DialogTitle className='bg-info p-1'><center>All Charge List</center></DialogTitle>
          <DialogContent>
            <ItemPap style={{ height: '190px' }}>
              <TableContainer>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                      <StyledTableCell className='p-1'>DescriptionOfGood</StyledTableCell>
                      <StyledTableCell className='p-1'>TaxableValue</StyledTableCell>
                      <StyledTableCell className='p-1'>NonTaxableValue</StyledTableCell>
                      <StyledTableCell className='p-1'>CGST_AMT</StyledTableCell>
                      <StyledTableCell className='p-1'>SGST_AMT</StyledTableCell>
                      <StyledTableCell className='p-1'>IGST_AMT</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {AllChargesList.map((item) => (
                      <StyledTableRow hover key={item.serialNumber}>
                        <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                        <StyledTableCell className='p-1'>{item.billName}</StyledTableCell>
                        <StyledTableCell className='p-1'>{item.taxableAmt}</StyledTableCell>
                        <StyledTableCell className='p-1'>{item.nonTaxableAmt}</StyledTableCell>
                        <StyledTableCell className='p-1'>{item.cgstAmt}</StyledTableCell>
                        <StyledTableCell className='p-1'>{item.sgstAmt}</StyledTableCell>
                        <StyledTableCell className='p-1'>{item.igstAmt}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </ItemPap>
          </DialogContent>
        </Dialog>
      </div>
      <div style={{ paddingLeft: '80px' }}>
        <Row>
          <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
            <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
          <Col xs={10}></Col>
          <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
          </Col>
        </Row>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <ItemPap style={{ height: '190px' }}>
              <Row>
                <Col xs={1}>
                  {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" > 
                        <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                </Col>
                <Col xs={11}>
                  <div>
                    <center><label style={{ fontFamily: 'Times New Roman', fontSize: '25px', textTransform: 'uppercase', color: 'red', fontWeight: 'bold' }}>Tracking</label></center>
                  </div>
                </Col>
              </Row>
              <div className='mt-1'>
                <Form.Check inline label='JOB.No' style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder' }} checked={radioValues === '1'} type='radio' value={'1'} onChange={RadioTrackingChangeHandle} />
                <Form.Check inline label='MAWB/MBL' style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder' }} checked={radioValues === '2'} type='radio' value={'2'} onChange={RadioTrackingChangeHandle} />
                <Form.Check inline label='HAWB/HBL' style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder' }} checked={radioValues === '3'} type='radio' value={'3'} onChange={RadioTrackingChangeHandle} />
                <center className='mt-1'>
                  <label style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>{LabelJob}</label>
                  <Form.Control size='sm' style={{ fontFamily: 'Times New Roman', width: '200px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }} value={Trackingvalues.job_no} onChange={Trackingjob_noChangeHandle} id='mawbJobHawb_No'
                    onKeyDown={TrackingJobNoKeyDown} />
                  <Button size='small' style={{ fontFamily: 'Times New Roman', }} className='mt-1' variant='contained' color='success' onClick={getJobTrackingDetailsOperation}>Track</Button>
                </center>
              </div>
            </ItemPap>
          </Grid>
          <Grid item xs={6} >
            <ItemPap style={{ height: '190px' }}>
              <div className='mt-2 '>
                <Row>
                  <Col xs={11}>
                    <Form.Label style={{ fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'darkBlue' }}>JOB STATUS</Form.Label>
                  </Col>
                  <Col xs={1}>
                    {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>  */}
                  </Col>
                </Row>
                <center><Form.Control size='sm' disabled className='jobStsCss' value={Trackingvalues.job_status} onChange={Trackingjob_statusChangeHandle} /></center>
              </div>
              <div className='mt-3 mb-1'>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' color='success' size='small' onClick={downloadClCopy}>Cheacklist</Button>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' color='primary' size='small' onClick={downloadBOECopy}>BOE/SB</Button>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' color='info' size='small' onClick={downloadPackingListCopy}>PackingList</Button>
              </div>
              <div>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' size='small' color='primary' onClick={downloadTspCopy}>TSP</Button>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' size='small' color='warning' onClick={downloadInvoiceCopy}>Invoice</Button>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' size='small' color='primary' onClick={DialogNgBillHandleOpen}>NG_Bill</Button>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' size='small' color='success' onClick={downloadDutyCopy}>DutyBill</Button>
                <Button style={{ fontFamily: 'Times New Roman', marginRight: '0.5%' }} variant='contained' size='small' color='info' onClick={DialogAllChargListOpen}>ALL ChargeList</Button>
              </div>
            </ItemPap>
          </Grid>
          <Grid item xs={6}>
            <Grid item xs={12}>
              <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>JOB DETAILS</label></center>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>JOB.NO</StyledTableCell>
                      <StyledTableCell className='p-1'>ENTERY_DATE</StyledTableCell>
                      <StyledTableCell className='p-1'>MAWB.NO</StyledTableCell>
                      <StyledTableCell className='p-1'>HAWB.NO</StyledTableCell>
                      <StyledTableCell className='p-1'>TOTAL_INV</StyledTableCell>
                      <StyledTableCell className='p-1'>TOTAL_PCS</StyledTableCell>
                      <StyledTableCell className='p-1'>GROSS_WGT</StyledTableCell>
                      <StyledTableCell className='p-1'>CHARGABLE_WGT</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.countryName}>
                        <StyledTableCell>{item.consignmentNumber}</StyledTableCell>
                        <StyledTableCell>{item.transitDate}</StyledTableCell>
                        <StyledTableCell>{item.wayBillNumber}</StyledTableCell>
                        <StyledTableCell>{item.hawb_no}</StyledTableCell>
                        <StyledTableCell>{item.totalInvoice}</StyledTableCell>
                        <StyledTableCell>{item.totalCarton}</StyledTableCell>
                        <StyledTableCell>{item.totalWeight}</StyledTableCell>
                        <StyledTableCell>{item.weight}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>ORIGIN DETAILS</label></center>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>ORGIN COUNTRY</StyledTableCell>
                      <StyledTableCell className='p-1'>MODE</StyledTableCell>
                      <StyledTableCell className='p-1'>ORIGIN PORT</StyledTableCell>
                      <StyledTableCell className='p-1'>SHIPMENT COMPANY NAME</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.importer_iec_no}>
                        <StyledTableCell>{item.countryName}</StyledTableCell>
                        <StyledTableCell>{item.transitTypeName}</StyledTableCell>
                        <StyledTableCell>{item.origin_portName}</StyledTableCell>
                        <StyledTableCell>{item.shipmentCompanyName}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>IMPORTER/EXPORTER DETAILS</label></center>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>IEC CODE</StyledTableCell>
                      <StyledTableCell className='p-1'>IMPORTER/EXPORTER NAME</StyledTableCell>
                      <StyledTableCell className='p-1'>BR CODE</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.ad_code}>
                        <StyledTableCell>{item.importer_iec_no}</StyledTableCell>
                        <StyledTableCell>{item.importer_name}</StyledTableCell>
                        <StyledTableCell>{item.branch_code}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>AD CODE</StyledTableCell>
                      <StyledTableCell className='p-1'>STATE</StyledTableCell>
                      <StyledTableCell className='p-1'>ADDRESS</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.customPointCode}>
                        <StyledTableCell>{item.ad_code}</StyledTableCell>
                        <StyledTableCell>{item.importerState}</StyledTableCell>
                        <StyledTableCell>{item.importerAddress}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>CLEARANCE DETAILS</label></center>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>CLEARANCE_PORT_CODE</StyledTableCell>
                      <StyledTableCell className='p-1'>CLEARANCE_PORT_NAME</StyledTableCell>
                      <StyledTableCell className='p-1'>TRANSIST_DATE</StyledTableCell>
                      <StyledTableCell className='p-1'>ARRIVAL_DATE</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.customPointCode}>
                        <StyledTableCell>{item.customPointCode}</StyledTableCell>
                        <StyledTableCell>{item.customPointName}</StyledTableCell>
                        <StyledTableCell>{item.transitDate}</StyledTableCell>
                        <StyledTableCell>{item.expectedArrivalDateTime}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>BOE/SB DETAILS</label></center>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>BOE/SB NO</StyledTableCell>
                      <StyledTableCell className='p-1'>BOE/SB DATE</StyledTableCell>
                      <StyledTableCell className='p-1'>ASSESSABLE VALUE</StyledTableCell>
                      <StyledTableCell className='p-1'>DUTY AMOUNT</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.boe_no}>
                        <StyledTableCell>{item.boe_no}</StyledTableCell>
                        <StyledTableCell>{item.boe_date}</StyledTableCell>
                        <StyledTableCell>{item.assableValue}</StyledTableCell>
                        <StyledTableCell>{item.dutyAmt}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>TSB DETAILS</label></center>
              <TableContainer sx={{ maxHeight: 100 }}>
                <Table stickyHeader className='table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell className='p-1'>TSB_PAID_BY</StyledTableCell>
                      <StyledTableCell className='p-1'>TSB_PAID_TO</StyledTableCell>
                      <StyledTableCell className='p-1'>TSB_PAID_DATE</StyledTableCell>
                      <StyledTableCell className='p-1'>TSB_PAID_AMOUNT</StyledTableCell>
                      <StyledTableCell className='p-1'>TSB_PAID_REMARKS</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {TrackingDetailsOperation.map((item) => (
                      <StyledTableRow hover key={item.tspPaidBy}>
                        <StyledTableCell>{item.tspPaidBy}</StyledTableCell>
                        <StyledTableCell>{item.tspPaidTo}</StyledTableCell>
                        <StyledTableCell>{item.tspPaidDate}</StyledTableCell>
                        <StyledTableCell>{item.tspAmt}</StyledTableCell>
                        <StyledTableCell>{item.remarks}</StyledTableCell>
                      </StyledTableRow>))}
                  </TableBody>
                </Table>
              </TableContainer>
              <br></br>
              <Divider />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <center><label style={{ fontFamily: 'Times New Roman', fontSize: '13px', fontWeight: 'bold', color: 'red' }}>Tracking History DetailS</label></center>
            <TableContainer sx={{ maxHeight: 770 }}>
              <Table stickyHeader className='table table-bordered'>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell className='p-1'>OprLocation</StyledTableCell>
                    <StyledTableCell className='p-1'>UserName</StyledTableCell>
                    <StyledTableCell className='p-1'>OprDate</StyledTableCell>
                    <StyledTableCell className='p-1'>OprSts</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {JobTrackingDetailsOperation.map((item) => (
                    <StyledTableRow hover key={item.operationStatus}>
                      <StyledTableCell>{item.userLocation}</StyledTableCell>
                      <StyledTableCell>{item.userName}</StyledTableCell>
                      <StyledTableCell>{item.operationDate}</StyledTableCell>
                      <StyledTableCell>{item.operationStatus}</StyledTableCell>
                    </StyledTableRow>))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default Tracking